// isFailedAsset — detects a "fake" / failed generated asset so the UI can
// render a real error state instead of presenting a placeholder as usable.
//
// Matches on the URL and on a structured error only — NOT on caption text.
// (A legitimate caption could contain the words "generation failed"; matching
// caption substrings would cause false positives.)
//
// True when:
//   - no url
//   - the url is a placehold.co stand-in
//   - the url has "Generation Failed" baked in (legacy fabricated URLs)
//   - a structured error object/string is present on the asset
//
// Usage: isFailedAsset(url, error)
export default function isFailedAsset(url, error) {
  if (!url) return true;
  const u = String(url);
  if (/placehold\.co/i.test(u)) return true;
  // Legacy fabricated URLs encode the space as "+" or "%20"
  // (…?text=Generation+Failed%0A…), so normalize before matching.
  const norm = u.replace(/\+/g, ' ').replace(/%20/gi, ' ');
  if (/generation\s*failed/i.test(norm)) return true;
  if (error) return true;
  return false;
}
